import { createContext, useState } from "react";

const SelectedContext = createContext({
    selectedItems: [],
    setSelectedItems: () => { },
    removeItems: () => { },
});

export function SelectedContextProvider(props) {
    const [selectedItems, setSelectedItems] = useState([]);

    const removeItems = () => setSelectedItems([]);

    const context = {
        selectedItems,
        removeItems,
        setSelectedItems
    };

    return (
        <SelectedContext.Provider value={context}>
            {props.children}
        </SelectedContext.Provider>
    );
}

export default SelectedContext;
